import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem('kota_token');
    if (!token) return next.handle(req);
    return next.handle(
      req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
        withCredentials: true
      })
    );
  }
}
